import React, { useState, useEffect } from 'react';
import { FiX, FiSave } from 'react-icons/fi';
import '../styles/editPlayerNumberModal.css';

export default function EditPlayerNumberModal({ 
    isOpen, 
    onClose, 
    player,
    currentNumber,
    occupiedNumbers = [],
    onSave
}) {
    const [number, setNumber] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            setNumber(currentNumber || '');
            setError('');
        }
    }, [isOpen, currentNumber]);

    const handleSave = () => {
        // Проверка на пустое значение
        if (!number || number === '') {
            setError('Укажите номер игрока');
            return;
        }

        const numValue = parseInt(number);

        // Проверка диапазона
        if (numValue < 0 || numValue > 99) {
            setError('Номер должен быть от 0 до 99');
            return;
        }

        // Проверка на дубликат (исключая текущий номер игрока)
        if (numValue !== parseInt(currentNumber) && occupiedNumbers.includes(numValue)) {
            setError(`Номер ${numValue} уже занят другим игроком`);
            return;
        }

        onSave(number);
        onClose();
    };

    const handleNumberChange = (value) => {
        // Ограничиваем ввод двумя цифрами
        if (value.length > 2) {
            value = value.slice(0, 2);
        }
        setNumber(value);
        setError('');
    };

    if (!isOpen) return null;

    return (
        <div className="modalOverlay" onClick={(e) => e.target.className === 'modalOverlay' && onClose()}>
            <div className="editNumberModalContent">
                <div className="modalHeader">
                    <h3>Изменить игровой номер</h3>
                    <button className="closeButton" onClick={onClose}>
                        <FiX />
                    </button>
                </div>

                <div className="modalBody">
                    <div className="playerInfo">
                        <strong>{player?.family} {player?.name} {player?.father_name}</strong>
                    </div>

                    <div className="numberInputGroup">
                        <label>Игровой номер *</label>
                        <input
                            type="number"
                            min="0"
                            max="99"
                            maxLength={2}
                            value={number}
                            onChange={(e) => handleNumberChange(e.target.value)}
                            placeholder="Введите номер"
                            className={error ? 'error' : ''}
                            autoFocus
                        />
                        {error && <span className="errorMessage">{error}</span>}
                    </div>

                    <div className="occupiedNumbersHint">
                        <small>Занятые номера: {occupiedNumbers.length > 0 ? occupiedNumbers.sort((a, b) => a - b).join(', ') : 'нет'}</small>
                    </div>
                </div>

                <div className="modalFooter">
                    <button className="cancelButton" onClick={onClose}>
                        Отмена
                    </button>
                    <button className="saveButton" onClick={handleSave}>
                        <FiSave />
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    );
}
